import { Notification } from '@fund-base/types/notifications/notifications.types';

export interface NotificationsState {
  notifications?: Notification[];
}

export const initialNotificationsState: NotificationsState = {
  notifications: [],
};
